import { Form } from "react-bootstrap";
import LayoutMaster from "../components/layout/layout_master";
import reset_password from "lib/worker/api/reset_password";
import { useState, useEffect } from "react";
import { CenterProps } from "lib/all_type/center_props";
import { MaxButton, StatusMaxButton } from "components/view/button";
import Link from "next/link";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { MuiTextFieldFrom } from "components/view/text_field_from";
import { useRouter } from "next/router";
import React from "react";
import { prefix } from "lib/worker/client";

interface NewPasswordProps extends CenterProps {
  infomation: CheckWithPrefixResponse;
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

export default function NewPassword(props: NewPasswordProps) {
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [spinner, setSpinner] = useState<boolean>(false);
  const router = useRouter();
  const [lineid, setlineid] = useState<string | null | undefined>(null);

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: props.infomation.domain });
    setlineid(infomations.lineidchat);
  }, []);

  const onSubmit = () => {
    setSpinner(true);
    reset_password({ password: password, confirm_password: confirmPassword })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "เปลี่ยนรหัสผ่าน",
        description: "เว็บ คาสิโน และ สล็อตออนไลน์ คาสิโน",
      }}
      information={props.infomation}
    >
      <div className="children-top">
        <br></br>
        <h1 className="center-content">เปลี่ยนรหัสผ่านใหม่</h1>
        <div className="container margin-top-20 row center-content ">
          <Form>
            <Form.Group
              className="title-left"
              controlId="exampleForm.ControlInput1"
            >
              <div className="margin-top-20">
                <MuiTextFieldFrom
                  title="รหัสผ่านใหม่"
                  value={password}
                  type="password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                ></MuiTextFieldFrom>
              </div>
            </Form.Group>
            <Form.Group
              className="title-left"
              controlId="exampleForm.ControlInput1"
            >
              <div style={{ paddingTop: 20 }}>
                <MuiTextFieldFrom
                  title="ยืนยันรหัสผ่านใหม่"
                  value={confirmPassword}
                  type="password"
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                ></MuiTextFieldFrom>
              </div>
            </Form.Group>
            <div className="margin-top-20">
              <MaxButton
                title="ยืนยัน"
                status={StatusMaxButton.submit}
                onClick={onSubmit}
                loading={spinner}
              ></MaxButton>
            </div>
          </Form>
          <h2
            className="font-red margin-top-20"
            style={{ fontSize: 16, marginLeft: 10 }}
          >
            *พบปัญหากรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางแชท{" "}
            {router.pathname.includes("contact") == false && (
              <>
                {" "}
                {lineid != null ? (
                  <Link href={lineid}>
                    <a>
                      <span>คลิก</span>
                    </a>
                  </Link>
                ) : (
                  <Link href={`/contact/${prefix}`}>
                    <a>
                      <span>คลิก</span>
                    </a>
                  </Link>
                )}
              </>
            )}
          </h2>
        </div>
      </div>
    </LayoutMaster>
  );
}
